import { generateId } from '@freelancer/datastore/testing/helpers';
import type {
  ContestRubricSubmission,
  ContestRubricSubmissionScore,
} from './contest-rubric-submissions.model';

export interface GenerateContestRubricSubmissionOptions {
  readonly id?: number;
  readonly entryId?: number;
  readonly userId?: number;
  readonly rubricId?: number;
  readonly contestId?: number;
  readonly comment?: string;
  readonly scores?: readonly ContestRubricSubmissionScore[];
}

/**
 * Generates a ContestRubricSubmission document within the datastore.
 */
export function generateContestRubricSubmissionObject({
  id = generateId(),
  entryId = generateId(),
  userId = generateId(),
  contestId = generateId(),
  rubricId = generateId(),
  scores = [],
  comment,
}: GenerateContestRubricSubmissionOptions): ContestRubricSubmission {
  return {
    id,
    entryId,
    contestId,
    userId,
    rubricId,
    scores,
    comment,
  };
}

export function withContestRubricSubmissionScore({
  id = generateId(),
  submissionId = generateId(),
  contestRubricItemId = generateId(),
  score = 0,
  comment = undefined,
}: Partial<ContestRubricSubmissionScore>): ContestRubricSubmissionScore {
  return {
    id,
    submissionId,
    contestRubricItemId,
    score,
    comment,
  };
}
